<template>
  <section class="wrap-dashboard">
    <AttendanceGraphic />
    <!-- <Kanban /> -->
    <ModalVersion />
  </section>
</template>

<script>
import AttendanceGraphic from "@/components/graficos/AttendanceGraphic.vue"
//import Kanban from "@/components/kanban/KanbanBoard.vue"
import ModalVersion from "@/components/sistema/ModalVersion.vue"

export default {
  name: "Dashboard",
  components: {
    AttendanceGraphic,
    //Kanban,
    ModalVersion
  }
}
</script>

<style lang="scss" scoped></style>
